import fetch from 'auth/FetchInterceptor'

const TroubleshootingService = {}

TroubleshootingService.getErrorListDynamic = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/Error/GetErrorsDynamic?index=${params.index}&size=10`,
        method: 'post',
        data: params.finalQuery,
    })
}

TroubleshootingService.addError = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/Error',
        method: 'post',
        data: data,
    })
}

TroubleshootingService.deleteTroubleshooting = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/Error/${params}`,
        method: 'delete',
        params,
    })
}

TroubleshootingService.deleteTroubleshootingAttachment = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/Error/DeleteErrorAttachment/${params}`,
        method: 'delete',
        params,
    })
}

TroubleshootingService.getTroubleshootingDetail = function (params) {
  return fetch({
      url: process.env.REACT_APP_API_URL+`portal/Error/${params}`,
      method: 'get',
      params,
  })
}

TroubleshootingService.updateTroubleshooting = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL+'portal/Error',
        method: 'put',
        data: data,
    })
}

export default TroubleshootingService
